import React, { useEffect, useRef, useState } from "react";
import "../CreateCompany/CreateCompany.css";
import { Form } from "react-router-dom";
import Select from "react-select";
import axios from "../../API/axios";
import DatePicker from "react-datepicker";
import moment from "moment";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import Flatpickr from 'react-flatpickr';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from "react-i18next";

const UpdateCompany = ({ showUpdateModal,setCompanyDetails, closeUpdateModal, compUid, getCompanyList, companyDetails }) => {
  const { t } = useTranslation();

  const sessionId = localStorage.getItem("sessionId");
  const [display, setDisplay] = useState(false);

  const [companyData, setCompanyData] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyAbout, setCompanyAbout] = useState("");
  const [companyTagline, setCompanyTagline] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyWebsiteError, setCompanyWebsiteError] = useState("");
  const [companyTurnover, setCompanyTurnover] = useState(null);
  const [description, setDescription] = useState("");
  const [comincorpDate, setComincorpDate] = useState(null);
  const [publicUrl, setPublicUrl] = useState("");
  const [endDate, setEndDate] = useState("");

  //   State for toaster
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
    const language = localStorage.getItem("Lang");

console.log("ssssss", companyDetails);

  useEffect(() => {
    if (companyDetails) {
      setCompanyName(companyDetails.compName);
      setCompanyEmail(companyDetails.email);
      setCompanyAbout(companyDetails.about);
      setCityId(companyDetails.cityId || "");
      setCitySearch(companyDetails.cityName || "");
      setIndustryId(companyDetails.industryId || "");
      setIndustrySearch(companyDetails.industryName || "");
      setCategoryId(companyDetails.companyCategoryId || "");
      setCategorySearch(companyDetails.companyCategoryName || "");
      setCompanySizeId(companyDetails.companySizeId || "");
      setCompanySizeSearch(companyDetails.companySizeName || "");
      setCompanyTagline(companyDetails.tagline);
      setCompanyWebsite(companyDetails.website);
      setPublicUrl(companyDetails.publicUrl);
      setCompanyTurnover(companyDetails.avgAnumTurnOver);
      setDescription(companyDetails.description);
      setComincorpDate(companyDetails.incorpDate);
    }
  }, [companyDetails]);


  //  useEffect(() => {
  //     const sessionId = localStorage.getItem("sessionId");
  //     if (sessionId) {
  //       (async () => { 
  //         await Promise.all([ 
  //           GetCompanyData()
  //         ]);
  //       })();
  //     } 
  //   }, []);

  //   Function to update company
  const validateWebsite = (value) => {
    const invalidPrefixes = /^(http:|https:|http:\/\/|https:\/\/|www\.)/i;
    const validDomainExtension = /\.[a-z]{2,}$/i; // basic extension check

    if (!value || value.trim() === "") {
      setCompanyWebsiteError("");
    } else if (invalidPrefixes.test(value)) {
      setCompanyWebsiteError("Website URL should not start with 'http', 'https', or 'www'.");
    } else if (!validDomainExtension.test(value)) {
      setCompanyWebsiteError("Website URL must include a valid domain extension (e.g., '.com', '.org').");
    } else {
      setCompanyWebsiteError("");
    }

    setCompanyWebsite(value);
  };

  const handleSubmit = async () => {
    setDisplay(true);
    // Validate website (if provided) before submitting
    if (companyWebsite && companyWebsite.trim() !== "") {
      const invalidPrefixes = /^(http:|https:|http:\/\/|https:\/\/|www\.)/i;
      const validDomainPattern = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/i; // domain + ext, optional path

      if (invalidPrefixes.test(companyWebsite.trim())) {
        setWarningToastMessage("Website URL should not start with 'http', 'https', or 'www'.");
        setShowWarningToast(true);
        return;
      }

      if (!validDomainPattern.test(companyWebsite.trim())) {
        setWarningToastMessage("Please provide a valid website URL.");
        setShowWarningToast(true);
        return;
      }
    }
    const body = {
      deviceType: "Web",
      sessionId: sessionId,
      compUid: compUid,
      compName: companyName,
      logoImage: "logoImage string",
      cityId: cityId,
      email: companyEmail,
      about: companyAbout,
      industryId: industryId,
      companyCategoryId: CategoryId,
      companySizeId: CompanySizeId,
      tagline: companyTagline,
      publicUrl: publicUrl,
      website: companyWebsite,
      incorpDate: moment(comincorpDate).format("DD/MM/YYYY") || null,
      avgAnumTurnOver: companyTurnover,
      description: description,
      langKey: language === "en" ? "" : language,
      
    };

    if (
      companyName === "" ||
      companyEmail === "" ||
      CategoryId === null ||
      CompanySizeId === null ||
    //  ( companyTagline === "" || companyTagline === null) ||
      cityId === null ||

      industryId === null
    ) {
      setWarningToastMessage("Please fill all fields");
      setShowWarningToast(true);
    } else {
      try {
        const res = await axios.post("/Company/UpdateCompany", body);
        
        console.log("1232222",res.data.message);
        
        setToastMessage(res.data.message);
        setShowToast(true);

        if (typeof setCompanyDetails === "function") {
          const updatedCompany = res.data && res.data.responseData ? res.data.responseData : {
            compUid: compUid,
            compName: companyName,
            email: companyEmail,
            about: companyAbout,
            cityId: cityId,
            cityName: citySearch,
            industryId: industryId,
            industryName: industrySearch,
            companyCategoryId: CategoryId,
            companyCategoryName: CategorySearch,
            companySizeId: CompanySizeId,
            companySizeName: CompanySizeSearch,
            tagline: companyTagline,
            website: companyWebsite,
            publicUrl: publicUrl,
            avgAnumTurnOver: companyTurnover,
            description: description,
            incorpDate: moment(comincorpDate).format("DD/MM/YYYY") || null,
            langKey: language === "en" ? "" : language,
          };

          setCompanyDetails(updatedCompany);
        }
 

        // Delay closing the modal so the toast has time to render
        setTimeout(() => {
          closeUpdateModal();
        }, 1000);

      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };

  //********City List Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);
  console.log("cityId===========>", citySearch);

  //********City List End  ********//

  //************************Industry Get Start  ************************//
  const [industryList, setIndustryList] = useState([]);
  const [industryId, setIndustryId] = useState(null);
  const [industrySearch, setIndustrySearch] = useState("");

  const getIndustry = () => {
    axios
      .get(`Master/GetFirmIndustryTypeDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.fitid,
          label: item.name,
        }));
        setIndustryList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (industrySearch) {
      getIndustry();
    }
  }, [industrySearch]);
  console.log("industryId", industrySearch);

  //************************Industry Get End  ************************//

  //********Category DDL Start  ********//
  const [Category, setCategory] = useState([]);
  const [CategoryId, setCategoryId] = useState(null);
  const [CategorySearch, setCategorySearch] = useState("");
  const getCategory = () => {
    axios
      .get(`Master/GetFirmCategoryDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.fcid,
          label: item.name,
        }));
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (CategorySearch) {
      getCategory();
    }
  }, [CategorySearch]);
  //********Category DDL End  ********//

  //********CompanySize DDL Start  ********//
  const [CompanySize, setCompanySize] = useState([]);
  const [CompanySizeId, setCompanySizeId] = useState(null);
  const [CompanySizeSearch, setCompanySizeSearch] = useState("");

  const getCompanySize = () => {
    axios
      .get(`Master/GetFirmSizeDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setCompanySize(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (CompanySizeSearch) {
      getCompanySize();
    }
  }, [CompanySizeSearch]);

  // useEffect(() => {
  //   if (companyData) {
  //     setCityId(companyData?.cityId);
  //     setCitySearch(companyData?.cityName);
  //     setIndustryId(companyData?.industryId);
  //     setIndustrySearch(companyData?.industryName);
  //     setCategoryId(companyData?.companyCategoryId);
  //     setCategorySearch(companyData?.companyCategoryName);
  //     setCompanySizeId(companyData?.companySizeId);
  //     setCompanySizeSearch(companyData?.companySizeName);
  //     //   setComincorpDate(companyData?.incorpDate);
  //   }
  // }, [companyData]);

  // useEffect(() => {
  //   if (showUpdateModal) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showUpdateModal]);

  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };

  const modalContentRef = useRef(null);

  return (
    <>
      {showUpdateModal && (
        <div
          className="modal fade show modal-lg "
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" ref={modalContentRef}>
              <div className="setting-header d-flex justify-content-between align-items-center p-2">
                <h6>{t("Manage Companies.Update Company")}</h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={closeUpdateModal}
                />

              </div>
              <Form>
                <div className="row p-4 pt-0 settings CreateCompany">
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("Manage Companies.Company Name")}<span className="text-danger ms-2">*</span>
                    </label>
                    {/* <input type='text' /> */}
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      invalid={display && companyName === ""}
                    />
                    {display && !companyName ? (
                      <span className="error_msg_lbl">{t("User Profile.Enter Company Name")} </span>
                    ) : null}
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("Manage Companies.Email Id")}<span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={companyEmail}
                      onChange={(e) => setCompanyEmail(e.target.value)}
                      invalid={display && companyEmail === ""}
                    />
                    {display && !companyEmail ? (
                      <span className="error_msg_lbl">{t("Manage Companies.Enter Email Id")} </span>
                    ) : null}
                  </div>

                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">{t("Manage Companies.About Company")} </label>
                    <textarea
                      id="about"
                      name="about"
                      rows="2"
                      cols="50"
                      value={companyAbout}
                      onChange={(e) => setCompanyAbout(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("Manage Companies.City")}<span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      value={cityData.find((option) => option.value === cityId)}
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      placeholder={t("Manage Companies.Select City")}
                      noOptionsMessage={() => t("modals.Search and Select City")}

                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      invalid={display && citySearch === ""}
                      styles={customStyles}
                    />
                    {display && !citySearch ? (
                      <span className="error_msg_lbl">{t("Manage Companies.Select City")} </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("Manage Companies.Industry")}<span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      value={industryList.find(
                        (option) => option.value === industryId
                      )}
                      onChange={(selectedOption) =>
                        setIndustryId(selectedOption.value)
                      }
                      options={industryList}
                      placeholder={t("Manage Companies.Select Industry")}
                      noOptionsMessage={() => "Search and Select Industry"}

                      onInputChange={(inputValue) => {
                        setIndustrySearch(inputValue);
                        // onMenuOpen={getIndustry} 
                      }}
                      invalid={display && industrySearch === ""}
                      styles={customStyles}
                    />
                    {display && !industryId ? (
                      <span className="error_msg_lbl">{t("Manage Companies.Select Industry")} </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("Manage Companies.Company Category")}<span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      value={Category.find(
                        (option) => option.value === CategoryId
                      )}
                      onChange={(selectedOption) =>
                        setCategoryId(selectedOption.value)
                      }
                      options={Category}
                      placeholder={t("Manage Companies.Select Category")}
                      noOptionsMessage={() => "Search and Select Company Category"}
                      onInputChange={(inputValue) => {
                        setCategorySearch(inputValue);
                      }}
                      invalid={display && CategorySearch === ""}
                      styles={customStyles}
                      // onMenuOpen={() => {
                      //   getCategory();
                      // }} 
                    />
                    {display && !CategoryId ? (
                      <span className="error_msg_lbl">
                        {t("Manage Companies.Select Company Category")}
                        {" "}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("Manage Companies.Company Size")}<span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      value={CompanySize.find(
                        (option) => option.value === CompanySizeId
                      )}
                      onChange={(selectedOption) =>
                        setCompanySizeId(selectedOption.value)
                      }
                      options={CompanySize}
                      placeholder={t("User Profile.Please Select Company Size")}
                      noOptionsMessage={() => "Search and Select Company Size"}
                      onInputChange={(inputValue) => {
                        setCompanySizeSearch(inputValue);
                      }}
                      invalid={display && CompanySizeSearch === ""}
                      styles={customStyles}
                      isSearchable={false}
                    />
                    {display && !CompanySizeId ? (
                      <span className="error_msg_lbl">
                        {t("User Profile.Please Select Company Size")}
                        {" "}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">{t("Manage Companies.Tagline")}</label>
                    <input
                      type="text"
                      value={companyTagline}
                      onChange={(e) => setCompanyTagline(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">{t("Manage Companies.Website")} </label>
                    <input
                      type="text"
                      value={companyWebsite}
                          onChange={(e) => validateWebsite(e.target.value)}
                    />
                        {companyWebsiteError ? (
                          <span className="error_msg_lbl">{companyWebsiteError}</span>
                        ) : null}
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">{t("User Profile.Public URL")} </label>
                    <input
                      type="text"
                      value={publicUrl}
                      onChange={(e) => setPublicUrl(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">{t("Manage Companies.Company Turn Over")} </label>
                    <input
                      type="number"
                      value={companyTurnover}
                      onChange={(e) => setCompanyTurnover(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">{t("Manage Companies.Incorporate Date")} </label>

                    <Flatpickr className='form-control' value={comincorpDate}
                      onChange={date => setComincorpDate(date[0])} id='dob' options={{
                        maxDate: "today", // Disables future dates
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Call the function to stop scroll on year
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Also prevent scroll when the picker opens
                        },
                      }} />
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">{t("Manage Companies.Description")} </label>
                    <textarea
                      id="address"
                      name="about"
                      rows="2"
                      cols="50"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={handleSubmit}
                    >
                      {t("Newsfeed.Update")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default UpdateCompany;
